<ng-container *lmsProfileGuard="'groups.notifications.sent'">
  <lms-toolbar [options]="toolbarConfig"></lms-toolbar>
  <lms-emails-list
    [listId]="groupEmailsListId"
    [options]="{ filters: filters, timezone: timezone }"
    (hideSearch)="setToolbarTable($event)"
  ></lms-emails-list>
</ng-container>
